import { render, staticRenderFns } from "./invite-by-email.vue?vue&type=template&id=3d22cf08&"
import script from "./invite-by-email.vue?vue&type=script&lang=js&"
export * from "./invite-by-email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports